import React from 'react'

export default function RenderNotificacao( ficha, el, data ) {
    if (el.tipoinfracao === "1 - Estágio não obrigatório do curso de Fisioterapia em quantitativo acima do permitido na Resolução 432/2013") {
        return (
            <>
                Suspensão imediata das atividades de estágio até a regularização
                conforme as Resolução COFFITO nº 432/2013, e a Lei 11.788/2008. Prestar
                esclarecimentos ao CREFITO-1 no prazo de três dias.
            </>
        )
    }
    else if (el.tipoinfracao === "2 - Estágio obrigatório de acadêmicos(as) do curso de Fisioterapia com ausência de acompanhamento de docente da Instituição de Ensino Superior (IES)") {
        return (
            <>
                Suspensão imediata das atividades de estágio dos(as) acadêmicos(as) da
                IES {el.instituicaoensino}, até a presença de supervisão direta de professor docente do curso. Este
                deve ser devidamente contratado pela Instituição de Ensino Superior com carga horária específica para
                esta atividade, com registro no sistema COFFITO/CREFITO.
            </>
        )
    }
    else if (el.tipoinfracao === "3 - Exercício ilegal da profissão de fisioterapeuta.") {
        return (
            <>
                Prestar esclarecimentos junto ao CREFITO-1, no prazo de 03 (três) dias, pela
                prestação do serviço de Fisioterapia realizado pelo(a)
                Sr.(a) {el.leigo} (RG: {el.rgleigo}; CPF: {el.cpfleigo}),
                pessoa não habilitada a executar atos privativos do fisioterapeuta, caracterizando exercício
                ilegal da profissão. Suspender imediatamente as atividades do(a) Sr(a). {el.leigo} por
                não possuir a devida habilitação.
            </>
        )
    }
    else if (el.tipoinfracao === "4 - Prática de atividades da Fisioterapia por pessoa não habilitada.") {
        return (
            <>
                Determinado a suspensão do exercício da Fisioterapia.
            </>
        )
    }
    else if (el.tipoinfracao === "5 - Delegação de função privativa do profissional fisioterapeuta.") {
        return (
            <>
                Prestar esclarecimentos junto ao CREFITO-1, no prazo de 03 (três) dias,
                sobre a atividade de Fisioterapia desenvolvida pelo(a) Sr(a) {el.leigo} (RG: {el.rgleigo}),
                fato que foi presenciado pela equipe de fiscalização do CREFITO-1.
                Fica intimado(a) a deixar de delegar, de forma imediata, suas funções privativas ao
                Sr(a) {el.leigo}, pessoa não habilitada a executar atos
                privativos do fisioterapeuta.
            </>
        )
    }
    else if (el.tipoinfracao === "6 - Empresa não possui a Declaração de Regularidade para Funcionamento (DRF) do serviço.") {
        return (
            <>
                Solicitar imediatamente a DRF no CREFITO-1.
            </>
        )
    }
    else if (el.tipoinfracao === "7 - Ausência do responsável técnico de Fisioterapia.") {
        return (
            <>
                Nomear entre os fisioterapeutas um profissional  para assumir as atribuições
                do exercício  da Responsabilidade Técnica no campo assistencial da Fisioterapia  para as atividades
                desenvolvidas no estabelecimento acima, conforme o <b>art. 5º da Resolução COFFITO nº 139/1992</b>.
            </>
        )
    }
    else if (el.tipoinfracao === "8 - Profissional com Licença Temporária de Fisioterapia vencida.") {
        return (
            <>
                Suspender imediatamente os atendimentos e encaminhar os pacientes para
                fisioterapeuta habilitado até a regularização da inscrição profissional definitiva junto ao CREFITO-1.
                Enviar, no prazo de 02 (dois) dias, a comprovação de encaminhamento dos pacientes indicando nome
                completo e registro profissional junto ao CREFITO-1 do fisioterapeuta que os acompanhará.
            </>
        )
    }
    else if (el.tipoinfracao === "9 - Falta de registro das atividades assistenciais fisioterapêuticas, no que tange sobre a obrigatoriedade do registro em prontuário pelo fisioterapeuta, da guarda e do seu descarte. (Responsável Técnico)") {
        return (
            <>
                Regularizar, de imediato, os registros dos atendimentos fisioterapêuticos após
                cada assistência, com a devida identificação do profissional que assistiu o paciente.
            </>
        )
    }
    // else if (el.tipoinfracao === "10 - Descumprimento a RDC-07.") {
    //     return (
    //         <>
    //             -Promover a devida adequação ao que é estabelecido nas Legislações acima citadas.
    //             <br />
    //             -Prestar esclarecimentos ao CREFITO-1, no prazo de 03 (três) dias, a contar da presente data, acerca do
    //             descumprimento da Resolução COFFITO Nº 139/92.
    //         </>
    //     )
    // }
    else if (el.tipoinfracao === "10 - Falta de registro de consultório.") {
        return (
            <>
                Promover o Registro de Consultório junto ao CREFITO-1, no prazo de 15 (quinze) dias.
            </>
        )
    }
    else if (el.tipoinfracao === "11 - Débitos com obrigações pecuniárias.") {
        return (
            <>
                O(a) profissional acima mencionado(a) fica notificado(a) a realizar as seguintes
                providências, no prazo de 10 (dez) dias úteis, a contar do recebimento deste documento: <b>Regularizar as
                    pendências pecuniárias junto ao CREFITO-1 ou apresentar defesa, conforme previsto no artigo 3º da Resolução
                    COFFITO 471/2016. Em caso de apresentação de defesa, deverá ser cumprindo o § 1º do Artigo 3º da Resolução
                    COFFITO 471/2016, juntando-se as provas que Vossa Senhoria entender necessárias.</b>
            </>
        )
    }
    else if (el.tipoinfracao === "12 - Descumprimento dos parâmetros assistenciais fisioterapêuticos.") {
        return (
            <>
                Promover, de imediato, a adequação do quantitativo de atendimentos por fisioterapeuta.
            </>
        )
    }
    else if (el.tipoinfracao === "13 - Descumprimento da Portaria CREFITO-1 Nº 046/2020") {
        return (
            <>
                Regularizar a situação do estabelecimento aos termos da Portaria CREFITO-1 Nº 046/2020,
                afim de estar em conformidade com as normas sanitárias vigentes no país, com relação a contenção de
                proliferação do COVID-19.
            </>
        )
    }
    else if (el.tipoinfracao === "14 - Descumprimento da legislação referente ao registro em prontuário dos fisioterapeutas.") {
        return (
            <>
                Promover, de imediato, os registros dos atendimentos fisioterapêuticos após cada
                assistência, com a devida identificação profissional.
            </>
        )
    }
    else if (el.tipoinfracao === "15 - Publicidade irregular - exposição de pacientes.") {
        return (
            <>
                Remover imediatamente, enquanto serviço de Fisioterapia, toda e qualquer publicidade
                que atente contra os preceitos éticos da profissão.
            </>
        )
    }
    else if (el.tipoinfracao === "16 - Publicidade irregular") {
        return (
            <>
                Remover imediatamente, enquanto serviço de Fisioterapia, toda e qualquer
                publicidade irregular.
            </>
        )
    }
    else if (el.tipoinfracao === "17 - Falta de Registro de Pessoa Jurídica junto ao CREFITO-1.") {
        return (
            <>
                Promover o Registro de Empresa no CREFITO-1, no prazo de 30 (trinta) dias.
            </>
        )
    }
    else if (el.tipoinfracao === "18 - Profissional sem registro de inscrição secundária.") {
        return (
            <>
                Promover inscrição secundária, no prazo de {el.prazo} dias.
            </>
        )
    }
    else if (el.tipoinfracao === "19 - Desvio de circunscrição, pois o fisioterapeuta não realizou a transferência.") {
        return (
            <>
                Promover transferência do CREFITO: {el.antigo} para o CREFITO: {el.novo}
            </>
        )
    }
    else if (el.tipoinfracao === "20 - Falta de cadastro do estabelecimento fiscalizado de Fisioterapia.") {
        return (
            <>
                Promover o cadastro do estabelecimento junto ao CREFITO-1, no prazo de 15 (quinze) dias.
            </>
        )
    }
}